import { useEffect } from 'react';
import JwtStore from "../flux/JwtStore";

const QUERY_STRING_MAX_SIZE = 2048;

export default function Login({

}) {
  useEffect(() => {

    localStorage.removeItem('partner-login');

    const intended = window.localStorage.getItem('intended-path') || '';

    const redirectUri = encodeURI(`${window.location.origin}/login-callback?intended=${intended}`);
    const refreshToken = JwtStore.getRefreshToken();

    const redirectQueryString = `redirect_uri=${redirectUri}`;

    let extraQueryString = '';

    if (
      refreshToken !== null &&
      window.localStorage.getItem('enrolled-in-biometric-auth') === '1'
    ) {
      extraQueryString += `&refresh_token=${refreshToken}`;
    } else {
      //
    }

    const queryStringSize = new Blob([redirectQueryString + extraQueryString]).size;

    // There are limits in the infrastructure for the query string size, we
    // ensure these limits are not surpassed and fallback to a shorter URL in
    // case they are.
    if (queryStringSize > QUERY_STRING_MAX_SIZE) {
      // In case we rewrite the query string, we want to let the infrastructure
      // know therefore we add a "rw=qs" parameter to the URL (short for
      // rewrite=query-string).
      window.location.replace(`${process.env.REACT_APP_AUTHENTICATION_DOMAIN}/login?${redirectQueryString}&rw=qs`);
    } else {
      window.location.replace(`${process.env.REACT_APP_AUTHENTICATION_DOMAIN}/login?${redirectQueryString}` + extraQueryString);
    }
  }, []);

  return null;
}
